import { render } from "./CheckList.vue?vue&type=template&id=67a5f62e&scoped=true"
import script from "./CheckList.vue?vue&type=script&lang=js"
export * from "./CheckList.vue?vue&type=script&lang=js"

import "./CheckList.vue?vue&type=style&index=0&id=67a5f62e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a5f62e"]])

export default __exports__